const airBrakes = [
  // ── SYSTEM COMPONENTS ─────────────────────────────────────────────────────────
  {
    id: "ab001",
    question: "What is the function of the air compressor in an air brake system?",
    options: [
      "To store compressed air for the brakes",
      "To pump air into the air storage tanks to maintain pressure",
      "To release air from the brake chambers",
      "To regulate the governor cut-in and cut-out pressure",
    ],
    answer: 1,
    explanation: "The air compressor pumps air into the storage tanks. It is driven by the engine via a belt or is gear-driven.",
  },
  {
    id: "ab002",
    question: "What does the air compressor governor do?",
    options: [
      "Controls the speed of the air compressor",
      "Controls when the compressor pumps air — cuts out at about 125 psi and cuts in at about 100 psi",
      "Regulates the brake chamber pressure",
      "Controls the spring brake release pressure",
    ],
    answer: 1,
    explanation: "The governor controls the compressor operation. It cuts out (stops pumping) at the maximum pressure (about 125 psi) and cuts back in (resumes pumping) at the minimum (about 100 psi).",
  },
  {
    id: "ab003",
    question: "What is the purpose of air storage tanks (reservoirs) in an air brake system?",
    options: [
      "To cool the compressed air",
      "To store compressed air so the brakes can be applied many times even if the compressor stops working",
      "To separate air from oil",
      "To provide air to the engine",
    ],
    answer: 1,
    explanation: "Air tanks store compressed air so that enough pressure is available for multiple brake applications, even if the compressor fails.",
  },
  {
    id: "ab004",
    question: "Why must air tanks be drained regularly?",
    options: [
      "To reduce tank pressure for safety",
      "To remove water and oil that accumulates and can cause brake failure in freezing temperatures or damage components",
      "To test the tank capacity",
      "To prevent the governor from cycling too often",
    ],
    answer: 1,
    explanation: "Compressed air carries moisture and oil vapors that condense in the tanks. Water can freeze in cold weather and cause brake failure. Oil contaminates brake components.",
  },
  {
    id: "ab005",
    question: "How often should air tanks be manually drained (if no automatic drain is present)?",
    options: [
      "Once a week",
      "Once a month",
      "At the end of each day's driving",
      "Only when the brakes feel soft",
    ],
    answer: 2,
    explanation: "Tanks without automatic drain valves should be drained at the end of each day's driving to prevent moisture and oil buildup.",
  },
  {
    id: "ab006",
    question: "What is the purpose of the safety relief valve in an air brake system?",
    options: [
      "To apply the brakes if air pressure drops too low",
      "To release excess air if the governor fails and pressure rises above a safe level (typically 150 psi)",
      "To prevent air from flowing backward in the system",
      "To warn the driver of low air pressure",
    ],
    answer: 1,
    explanation: "The safety relief valve protects the system by automatically venting air if pressure exceeds the safe maximum (typically around 150 psi), preventing tank rupture.",
  },
  {
    id: "ab007",
    question: "What is the purpose of the one-way check valve between the wet and dry tanks?",
    options: [
      "To drain water from the wet tank",
      "To prevent air from flowing back from the supply tank if the compressor fails",
      "To equalize pressure between tanks",
      "To control brake application pressure",
    ],
    answer: 1,
    explanation: "Check valves prevent compressed air from flowing backward. If the compressor fails, the supply in the secondary tanks remains available for braking.",
  },
  {
    id: "ab008",
    question: "What is the 'wet tank' in an air brake system?",
    options: [
      "The tank closest to the brake chambers",
      "The first tank that receives air from the compressor — it collects most of the moisture and oil",
      "A tank filled with brake fluid",
      "A reserve tank used only in emergencies",
    ],
    answer: 1,
    explanation: "The wet tank (supply tank) is the first tank after the compressor. It collects the most moisture and oil because air is hottest and most saturated when it first enters.",
  },
  {
    id: "ab009",
    question: "What is the purpose of the alcohol evaporator in an air brake system?",
    options: [
      "To cool the compressed air before it enters the tanks",
      "To inject alcohol into the system to prevent moisture from freezing in lines and valves during cold weather",
      "To lubricate the air compressor",
      "To remove oil from the compressed air",
    ],
    answer: 1,
    explanation: "Alcohol evaporators inject alcohol vapors into the air system to lower the freezing point of moisture in the lines and valves, preventing freeze-up in cold weather.",
  },
  {
    id: "ab010",
    question: "What is the purpose of the air dryer in an air brake system?",
    options: [
      "To dry the road surface for better braking",
      "To remove moisture and contaminants from compressed air before it reaches the tanks and valves",
      "To heat the air tanks in cold weather",
      "To reduce noise from the air system",
    ],
    answer: 1,
    explanation: "An air dryer uses a desiccant or refrigeration to remove moisture and oil from compressed air, protecting the entire air system from corrosion and freeze-up.",
  },
  // ── BRAKE COMPONENTS ──────────────────────────────────────────────────────────
  {
    id: "ab011",
    question: "What is an S-cam brake?",
    options: [
      "A type of disc brake",
      "The most common type of drum brake for heavy vehicles, where an S-shaped cam pushes brake shoes against the drum",
      "A spring brake design",
      "A type of ABS sensor",
    ],
    answer: 1,
    explanation: "S-cam (S-camshaft) drum brakes are the most common type on heavy commercial vehicles. The S-shaped cam rotates when the brake rod pushes it, forcing brake shoes outward against the drum.",
  },
  {
    id: "ab012",
    question: "What is the function of the slack adjuster?",
    options: [
      "To regulate air pressure to the brake chambers",
      "To adjust the distance between the brake shoes and drum — it transfers force from the pushrod to the S-cam",
      "To adjust spring brake tension",
      "To control the timing of brake application",
    ],
    answer: 1,
    explanation: "Slack adjusters link the brake chamber pushrod to the brake S-cam. They also compensate for brake lining wear, maintaining proper pushrod stroke.",
  },
  {
    id: "ab013",
    question: "What is the maximum pushrod stroke allowed before brakes are considered out of adjustment?",
    options: [
      "1 inch for all brake chambers",
      "It varies by chamber size — but if the pushrod travel exceeds the limit for that chamber, the brakes are out of adjustment",
      "2 inches for all chambers",
      "3 inches for all chambers",
    ],
    answer: 1,
    explanation: "Maximum allowed stroke varies by chamber size and type. Common limits are about 1.75 to 2 inches for standard chambers. Out-of-adjustment brakes reduce stopping ability significantly.",
  },
  {
    id: "ab014",
    question: "What is a 'brake chamber'?",
    options: [
      "The section of the brake drum where the shoes contact",
      "A round metal container that converts air pressure into mechanical force to apply the brakes",
      "The area inside the drum",
      "The air reservoir dedicated to braking",
    ],
    answer: 1,
    explanation: "The brake chamber is a metal canister containing a diaphragm. Air pressure pushes the diaphragm, moving the pushrod to apply the brakes.",
  },
  {
    id: "ab015",
    question: "What is the function of the brake shoes and linings?",
    options: [
      "To push the drum against the wheel",
      "To press against the brake drum and create the friction that slows the vehicle",
      "To hold the brake chamber in place",
      "To seal the brake drum from moisture",
    ],
    answer: 1,
    explanation: "Brake shoes are curved metal pieces lined with friction material. When pressed against the rotating drum by the S-cam, they create friction to slow the vehicle.",
  },
  // ── AIR PRESSURE AND WARNINGS ─────────────────────────────────────────────────
  {
    id: "ab016",
    question: "The low air pressure warning light and buzzer must activate when air pressure falls below approximately:",
    options: [
      "25 psi",
      "60 psi",
      "90 psi",
      "100 psi",
    ],
    answer: 1,
    explanation: "Federal regulations require a low pressure warning to activate when air pressure drops below 60 psi (or half the governor cut-out pressure). You must stop safely if this occurs.",
  },
  {
    id: "ab017",
    question: "What should you do if the low air pressure warning activates while driving?",
    options: [
      "Increase speed to reach the next town faster",
      "Continue driving — the warning is normal during heavy braking",
      "Stop the vehicle safely as soon as possible and investigate the cause",
      "Apply the parking brake immediately",
    ],
    answer: 2,
    explanation: "Low air pressure is a serious warning. Stop safely immediately because pressure will continue to drop, and the spring brakes will apply automatically if it drops too far.",
  },
  {
    id: "ab018",
    question: "At what air pressure level do spring brakes automatically apply?",
    options: [
      "100 psi",
      "60 psi",
      "Between 20 and 45 psi (varies by system)",
      "10 psi",
    ],
    answer: 2,
    explanation: "Spring brakes apply automatically when air pressure drops to about 20–45 psi (the exact level varies). This is a safety feature to stop the vehicle if air is lost.",
  },
  {
    id: "ab019",
    question: "Normal operating air pressure for a truck air brake system is approximately:",
    options: [
      "30–60 psi",
      "60–90 psi",
      "100–125 psi",
      "150–175 psi",
    ],
    answer: 2,
    explanation: "Normal operating pressure is approximately 100–125 psi. The governor cuts out at about 125 psi and cuts back in at about 100 psi.",
  },
  {
    id: "ab020",
    question: "Before driving a vehicle with air brakes, the air pressure should be:",
    options: [
      "At least 50 psi",
      "Built up to normal operating range (100–125 psi) before driving",
      "At exactly 100 psi — no more or less",
      "The same as atmospheric pressure",
    ],
    answer: 1,
    explanation: "Build air pressure to the normal operating range before driving. Check that all gauges show proper readings and warning lights are off.",
  },
  // ── SPRING BRAKES AND PARKING BRAKES ──────────────────────────────────────────
  {
    id: "ab021",
    question: "Spring brakes work on the principle that:",
    options: [
      "Air pressure applies them and springs release them",
      "Springs apply them when air pressure is released, and air pressure holds them released during normal operation",
      "They are applied manually and released by air",
      "They operate independently of the air system",
    ],
    answer: 1,
    explanation: "Spring brakes are mechanically applied by large coil springs. Air pressure compresses the springs to hold the brakes released. Loss of air = spring brakes apply.",
  },
  {
    id: "ab022",
    question: "The parking brake control (spring brake control) is typically a:",
    options: [
      "Foot pedal",
      "Yellow diamond-shaped push-pull knob",
      "Red octagon-shaped knob",
      "Green toggle switch",
    ],
    answer: 1,
    explanation: "The parking/spring brake control is a yellow, diamond-shaped push-pull knob. Pulling it out sets the brakes (releases air); pushing it in releases the parking brakes.",
  },
  {
    id: "ab023",
    question: "The trailer air supply control (the red knob) is used to:",
    options: [
      "Activate the trailer's spring brakes in an emergency",
      "Control the air supply to the trailer — pulling it out shuts off air to the trailer (emergency position)",
      "Apply only the trailer service brakes",
      "Control trailer lights",
    ],
    answer: 1,
    explanation: "The red octagonal trailer air supply valve controls air to the trailer. In the out (popped) position, it shuts off trailer air and applies trailer spring brakes — used in emergencies.",
  },
  {
    id: "ab024",
    question: "What is the 'modulating control valve' for spring brakes?",
    options: [
      "A valve that controls normal service brake application",
      "A hand-operated valve that allows graduated application of spring brakes when service brakes fail",
      "The governor control valve",
      "A safety valve that prevents over-pressure",
    ],
    answer: 1,
    explanation: "If service brakes fail, the modulating valve lets you gradually apply the spring brakes to control stopping, rather than a sudden full application.",
  },
  {
    id: "ab025",
    question: "Never 'fan' the brakes (pump them repeatedly) on a vehicle with spring brakes because:",
    options: [
      "It makes the brakes less effective on wet roads",
      "Each pump exhausts air, reducing tank pressure, and the spring brakes may suddenly apply",
      "It damages the S-cam",
      "It is hard on the tires",
    ],
    answer: 1,
    explanation: "Pumping air brakes rapidly depletes air pressure. If pressure drops to the spring brake engagement level, the spring brakes will suddenly apply, potentially causing loss of control.",
  },
  // ── DUAL AIR BRAKE SYSTEMS ────────────────────────────────────────────────────
  {
    id: "ab026",
    question: "What is a dual air brake system?",
    options: [
      "A system with two separate compressors",
      "A system with two separate air circuits — primary and secondary — sharing one set of controls but providing a backup if one system fails",
      "Air brakes on both the tractor and trailer",
      "A system for both front and rear axles only",
    ],
    answer: 1,
    explanation: "A dual air system has two separate circuits (primary and secondary). If one circuit fails, the other still supplies air so the driver can stop safely.",
  },
  {
    id: "ab027",
    question: "In a dual air brake system, the primary circuit typically controls:",
    options: [
      "Only the trailer brakes",
      "The rear drive axle brakes",
      "Only the front brakes",
      "The engine brake",
    ],
    answer: 1,
    explanation: "In most systems, the primary circuit controls the rear (drive axle) brakes, and the secondary circuit controls the front axle brakes and possibly the trailer.",
  },
  {
    id: "ab028",
    question: "Before driving a dual air brake vehicle, both air circuits should be checked. If air pressure in either system drops below ______, the low pressure warning will activate.",
    options: [
      "125 psi",
      "100 psi",
      "60 psi",
      "30 psi",
    ],
    answer: 2,
    explanation: "The warning activates for either system dropping below approximately 60 psi, alerting the driver before pressure falls to the spring brake engagement level.",
  },
  // ── PRE-TRIP TESTING ──────────────────────────────────────────────────────────
  {
    id: "ab029",
    question: "During the pre-trip static pressure test, how much should air pressure drop in one minute with the engine off and brakes not applied?",
    options: [
      "No more than 2 psi per minute for single vehicles, 3 psi for combination vehicles",
      "No more than 10 psi",
      "No more than 20 psi",
      "Any amount — some leakage is normal",
    ],
    answer: 0,
    explanation: "A properly maintained system should lose no more than 2 psi per minute (single vehicle) or 3 psi (combination) with brakes off and engine off.",
  },
  {
    id: "ab030",
    question: "During the pre-trip test with the brakes applied, air pressure should drop no more than:",
    options: [
      "2 psi in one minute",
      "3 psi for single vehicles, 4 psi for combination vehicles in one minute",
      "10 psi in 2 minutes",
      "Any leak with brakes applied is normal",
    ],
    answer: 1,
    explanation: "With brakes applied, acceptable leakage is 3 psi per minute for a single vehicle and 4 psi per minute for a combination vehicle.",
  },
  {
    id: "ab031",
    question: "To test the low air pressure warning, you should:",
    options: [
      "Pump the brakes until the warning activates",
      "With the engine off, fan the brakes to reduce air pressure until the warning device activates — it must activate before pressure drops below 60 psi",
      "Disconnect an air line",
      "Turn off the ignition while driving",
    ],
    answer: 1,
    explanation: "With the engine off, repeatedly apply the brake to drop pressure. The warning (light/buzzer) must come on before pressure drops below 60 psi to confirm it works.",
  },
  {
    id: "ab032",
    question: "To check if the spring brakes activate at the proper pressure, you should:",
    options: [
      "Release all air rapidly",
      "Fan the brakes to drop pressure below 20–45 psi and confirm the spring brakes apply",
      "Apply the parking brake and measure resistance",
      "Drive slowly and release all air",
    ],
    answer: 1,
    explanation: "Continue reducing pressure (by fanning brakes with engine off) past the warning point. Spring brakes should apply automatically at the spring brake cut-in pressure (20–45 psi).",
  },
  {
    id: "ab033",
    question: "After starting the engine, how quickly should air pressure build to the normal operating range (100–125 psi)?",
    options: [
      "In about 3 minutes at idle (typical)",
      "Immediately",
      "In at least 10 minutes",
      "Only while driving, not at idle",
    ],
    answer: 0,
    explanation: "Air pressure should build to normal operating range within about 3 minutes at idle. If it takes much longer, there may be a compressor or leak problem.",
  },
  {
    id: "ab034",
    question: "What does the 'governor cut-out' test verify?",
    options: [
      "That spring brakes apply at the correct pressure",
      "That the compressor stops pumping at the correct maximum pressure (about 125 psi)",
      "That the warning activates at the correct low pressure",
      "That the air dryer is working",
    ],
    answer: 1,
    explanation: "When pressure reaches the cut-out point (around 125 psi), the compressor should stop pumping. Verify by watching the pressure gauge stop rising at the correct level.",
  },
  // ── BRAKE FADE AND HEAT ────────────────────────────────────────────────────────
  {
    id: "ab035",
    question: "What causes brake fade on air brake systems?",
    options: [
      "Too much air pressure",
      "Overheating of brake drums and linings from excessive or prolonged braking, reducing friction effectiveness",
      "Wet brakes from rain",
      "ABS intervention",
    ],
    answer: 1,
    explanation: "Prolonged or excessive braking generates heat. Overheated brakes lose their ability to create friction — they fade. The drums expand and linings glaze.",
  },
  {
    id: "ab036",
    question: "On a long downgrade, the correct technique to avoid brake fade is:",
    options: [
      "Apply brakes continuously at moderate pressure throughout the descent",
      "Select a lower gear before starting down, use engine braking, and apply brakes intermittently to control speed",
      "Use only the parking brake on long grades",
      "Shift to neutral and coast with light brake pressure",
    ],
    answer: 1,
    explanation: "Use engine braking (low gear) as the primary speed control. Apply service brakes briefly to reduce speed by about 5 mph when needed, then release to let them cool.",
  },
  {
    id: "ab037",
    question: "If your brakes fade on a downgrade and you cannot slow down, you should:",
    options: [
      "Accelerate to maintain vehicle control",
      "Use a runaway truck ramp or escape ramp if available, or look for a safe place to stop",
      "Apply the parking brake fully",
      "Shift to the highest gear to reduce engine braking",
    ],
    answer: 1,
    explanation: "Head for a runaway truck ramp immediately if available. If not, look for other ways to stop safely — gravel areas, uphill grades, etc.",
  },
  {
    id: "ab038",
    question: "Heated brake drums are a sign of:",
    options: [
      "Normal operation during a descent",
      "Overheated brakes from overuse — stop and allow to cool before continuing",
      "Properly adjusted brakes",
      "The ABS working correctly",
    ],
    answer: 1,
    explanation: "Very hot drums indicate brakes are overheating from overuse. Overheated brakes can fade or fail. Stop and allow to cool. Do not douse with water — thermal shock can crack drums.",
  },
  // ── ABS ───────────────────────────────────────────────────────────────────────
  {
    id: "ab039",
    question: "What does ABS (Anti-lock Braking System) do on a vehicle with air brakes?",
    options: [
      "Increases maximum brake force",
      "Modulates brake pressure to prevent wheel lockup during hard braking, allowing the driver to maintain steering",
      "Automatically applies the brakes when following distance is too short",
      "Replaces service brakes in emergencies",
    ],
    answer: 1,
    explanation: "ABS rapidly modulates air pressure to brake chambers to prevent wheels from locking during hard stops, helping the driver maintain directional control.",
  },
  {
    id: "ab040",
    question: "When ABS activates, you should:",
    options: [
      "Pump the brakes to help ABS work better",
      "Release the brake pedal to stop ABS",
      "Apply firm, steady pressure to the brake pedal and steer around obstacles as needed",
      "Turn off the ABS switch",
    ],
    answer: 2,
    explanation: "Apply firm, steady pressure. ABS modulates automatically — you do not need to pump. You can steer while maintaining brake pressure.",
  },
  {
    id: "ab041",
    question: "The ABS warning light on a truck comes on during a pre-trip check and stays on. This means:",
    options: [
      "ABS is functioning normally",
      "The ABS has a malfunction — service brakes still work, but ABS protection may be reduced",
      "The spring brakes are engaged",
      "Air pressure is too high",
    ],
    answer: 1,
    explanation: "An illuminated ABS warning light indicates a system fault. The regular service brakes still function, but the ABS may not work correctly to prevent lockup.",
  },
  {
    id: "ab042",
    question: "ABS is required on CMVs manufactured after:",
    options: [
      "January 1, 1994 (trucks) and March 1, 1998 (trailers)",
      "January 1, 2000",
      "January 1, 1990",
      "ABS is not federally required",
    ],
    answer: 0,
    explanation: "Federal law required ABS on new trucks and buses after March 1, 1997, and on new trailers after March 1, 1998 (some 1994/1995 dates apply to some truck tractors).",
  },
  // ── COMBINATION VEHICLES AND TRAILER BRAKES ────────────────────────────────────
  {
    id: "ab043",
    question: "The trailer hand valve (also called the trailer brake valve or hand valve) controls:",
    options: [
      "Only the trailer parking brakes",
      "The service brakes on the trailer only — used for testing and to prevent trailer jackknife",
      "Both the tractor and trailer service brakes",
      "The trailer spring brakes",
    ],
    answer: 1,
    explanation: "The trailer hand valve applies only the trailer service brakes. It is used for testing trailer brakes and can help prevent jackknife — but don't use it in normal driving.",
  },
  {
    id: "ab044",
    question: "Why should you NOT use the trailer hand valve while driving for normal braking?",
    options: [
      "It uses too much air pressure",
      "It can cause the trailer brakes to lock up, potentially causing a jackknife",
      "It applies all brakes at full force",
      "It disconnects the trailer from the tractor",
    ],
    answer: 1,
    explanation: "Using the trailer hand valve alone during driving applies only the trailer brakes, which can lock the trailer wheels and cause a jackknife.",
  },
  {
    id: "ab045",
    question: "What is the tractor protection valve?",
    options: [
      "A valve that protects the engine from overheating",
      "A valve that automatically closes to protect the tractor air supply if the trailer develops a severe air leak",
      "A valve that prevents trailer air from flowing to the tractor",
      "A valve that controls fifth wheel engagement",
    ],
    answer: 1,
    explanation: "The tractor protection valve closes automatically when trailer air pressure drops severely, maintaining tractor air so the driver can stop safely even if the trailer line ruptures.",
  },
  {
    id: "ab046",
    question: "When coupling a tractor to a trailer, after connecting the glad hands you should:",
    options: [
      "Move the tractor immediately",
      "Supply air to the trailer system and check that the trailer brakes release and apply properly",
      "Only check the air gauge",
      "Check only the red glad hand connection",
    ],
    answer: 1,
    explanation: "After connecting glad hands, charge the trailer air system, then test trailer brakes by applying them from the hand valve and checking for proper response.",
  },
  {
    id: "ab047",
    question: "Glad hands must be cross-connected so that:",
    options: [
      "The service line connects to the emergency port",
      "The tractor service line connects to the trailer service port, and the emergency line to the emergency port",
      "Both service lines connect together",
      "The emergency lines connect together",
    ],
    answer: 1,
    explanation: "Blue (service) connects to blue, red (emergency) to red. Cross-connecting (service to emergency) is dangerous — it renders the trailer brakes ineffective.",
  },
  {
    id: "ab048",
    question: "What does 'charging the trailer air system' mean?",
    options: [
      "Adding electricity to the trailer batteries",
      "Releasing air to the trailer system to build pressure and release the trailer spring brakes",
      "Draining air from the trailer tanks",
      "Testing the trailer brake lights",
    ],
    answer: 1,
    explanation: "Charging the trailer supplies air through the emergency (supply) line, building pressure in the trailer tanks and releasing the trailer spring brakes.",
  },
  // ── BRAKE INSPECTION ──────────────────────────────────────────────────────────
  {
    id: "ab049",
    question: "During a brake inspection, you should check for:",
    options: [
      "Only brake fluid level",
      "Cracked or broken drums, worn linings, missing or broken components, proper adjustment (pushrod stroke), and no air leaks",
      "Only brake pedal height",
      "Only spring brake condition",
    ],
    answer: 1,
    explanation: "A complete brake inspection checks drums, shoes/linings, brake chambers, pushrod travel, hoses and lines for leaks, and all hardware for damage or missing parts.",
  },
  {
    id: "ab050",
    question: "If you hear air leaking from the brake system during inspection, you should:",
    options: [
      "Ignore minor leaks — they don't affect safety",
      "Report it and have it repaired before operating the vehicle",
      "Drive only on short trips until repaired",
      "Add more air pressure to compensate",
    ],
    answer: 1,
    explanation: "Any air leak in the brake system is a safety defect. The vehicle must not be operated until the leak is found and repaired.",
  },
  {
    id: "ab051",
    question: "What is the maximum allowable brake lining thickness before the brakes are out of service?",
    options: [
      "1/16 inch for disc brakes, 1/8 inch for drum brakes",
      "1/4 inch for all types",
      "It varies — typically 1/4 inch for drum brakes and specified minimums for disc brakes; brake lining must not be worn down to the shoes or rivets",
      "No minimum — use until complete wear",
    ],
    answer: 2,
    explanation: "Brake lining must not be worn to or below the minimum thickness (varies by manufacturer), cracked, or contaminated with oil or grease.",
  },
  {
    id: "ab052",
    question: "What is the purpose of the 'pushrod' in a brake chamber?",
    options: [
      "It supplies air to the chamber",
      "It transfers the mechanical force of the diaphragm to the slack adjuster to apply the brakes",
      "It controls the governor",
      "It connects the brake hose to the chamber",
    ],
    answer: 1,
    explanation: "The pushrod is the rod that moves outward when air fills the chamber, transferring force through the slack adjuster to turn the S-cam and apply the brakes.",
  },
  // ── ADVANCED CONCEPTS ─────────────────────────────────────────────────────────
  {
    id: "ab053",
    question: "What is a 'combination chamber' (also called a 'piggyback' chamber)?",
    options: [
      "A chamber that supplies air to two separate axles",
      "A brake chamber that combines both a service brake diaphragm and a spring brake in one unit",
      "An air dryer combined with a reservoir",
      "A chamber for use only on trailers",
    ],
    answer: 1,
    explanation: "Combination chambers (type 30/30 or similar) house both the service brake diaphragm and the spring brake mechanism in a single compact unit used on drive axles.",
  },
  {
    id: "ab054",
    question: "You should never 'cage' the spring brakes using the manual release bolt unless:",
    options: [
      "You want to park on a hill",
      "You are moving the vehicle in an emergency when there is no air available to release the spring brakes",
      "You want to test brake function",
      "You are going uphill",
    ],
    answer: 1,
    explanation: "Caging (mechanically compressing the springs) should only be done in emergencies to move the vehicle when air cannot be restored. Always re-cage and restore the system properly.",
  },
  {
    id: "ab055",
    question: "What is the purpose of the 'supply line' (emergency line) in a tractor-trailer air system?",
    options: [
      "It supplies air to operate the trailer service brakes",
      "It charges the trailer air tanks and controls the trailer spring brakes — low pressure causes the emergency (spring) brakes to apply",
      "It supplies air to the fifth wheel lubrication",
      "It connects the tractor service brakes to the trailer",
    ],
    answer: 1,
    explanation: "The supply (emergency) line maintains pressure in the trailer's tanks and keeps the spring brakes released. If it ruptures or uncouples, pressure drops and trailer spring brakes apply.",
  },
  {
    id: "ab056",
    question: "What is the 'service line' (blue line) in a tractor-trailer air system?",
    options: [
      "The line that charges the trailer air tanks",
      "The line that carries air to control the trailer service brakes when the foot pedal is applied",
      "The line that connects to the trailer spring brakes",
      "The backup power supply line",
    ],
    answer: 1,
    explanation: "The service line (blue, controlled by the foot valve) carries air pressure proportional to pedal application to the trailer relay valve, which applies the trailer service brakes.",
  },
  {
    id: "ab057",
    question: "What is a 'relay valve' on a trailer?",
    options: [
      "A valve that connects the two air lines from the tractor",
      "A valve that speeds up brake application and release on the trailer by using local air supply rather than requiring air to travel all the way from the tractor",
      "A valve that controls spring brake release",
      "An emergency shutoff valve",
    ],
    answer: 1,
    explanation: "Relay valves use air pressure from the service line as a signal. They apply local air from the trailer tanks to the brake chambers for faster, more responsive braking.",
  },
  // ── INSPECTION SEQUENCE AND TESTING ───────────────────────────────────────────
  {
    id: "ab058",
    question: "The pre-trip air brake inspection should be performed in which order?",
    options: [
      "Start the engine, check gauges, then drain tanks",
      "Drain tanks, start the engine, build pressure, test warnings, test spring brakes, test service brakes",
      "Only check gauges, then drive to test brakes",
      "Test service brakes first, then build air pressure",
    ],
    answer: 1,
    explanation: "Drain tanks → start engine → build to normal pressure → shut off engine → check for leaks → test warning at 60 psi → verify spring brake engagement → test service brakes while moving slowly.",
  },
  {
    id: "ab059",
    question: "How do you test the service brakes during a pre-trip inspection?",
    options: [
      "Apply them at highway speed and check stopping distance",
      "Move slowly (about 5 mph), apply the brakes firmly, and check that the vehicle stops straight without pulling",
      "Apply them while the vehicle is parked and check pedal feel",
      "Only check the brake gauges",
    ],
    answer: 1,
    explanation: "Test service brakes by moving slowly (~5 mph) and applying them firmly. The vehicle should stop without pulling to one side, making unusual noises, or feeling spongy.",
  },
  {
    id: "ab060",
    question: "When checking for air leaks by listening, what are you listening for?",
    options: [
      "The hiss of normal compressor operation",
      "Any hissing, squealing, or rush of air from lines, hoses, fittings, chambers, or valves",
      "Brake chamber vibration",
      "Drum noise when rotating",
    ],
    answer: 1,
    explanation: "With the system at full pressure and engine off, walk around the vehicle and listen for any escaping air sounds from fittings, lines, chambers, or valves.",
  },
  // ── SAFETY RULES ──────────────────────────────────────────────────────────────
  {
    id: "ab061",
    question: "What should you do if you find the air pressure gauge showing a lower than normal pressure just before a trip?",
    options: [
      "Drive to a shop to fix it",
      "Do not drive — identify and repair the leak before operating the vehicle",
      "Check after driving a few miles to see if it builds up",
      "Add more air to the system with a portable compressor",
    ],
    answer: 1,
    explanation: "Low pre-trip air pressure indicates a possible leak or compressor problem. Do not drive until the issue is diagnosed and corrected.",
  },
  {
    id: "ab062",
    question: "Brakes on a CMV must be maintained in which condition?",
    options: [
      "Within 10% of factory specification",
      "As required by FMCSA regulations — all brakes on all axles must function properly",
      "Only the front and rear axle brakes must work",
      "At least 50% braking capacity on each axle",
    ],
    answer: 1,
    explanation: "All brakes on all axles must be properly adjusted and functional. Operating with brakes out of service is a violation and a serious safety hazard.",
  },
  {
    id: "ab063",
    question: "What happens when air pressure in the brake system drops below a usable level and the vehicle has no spring brakes?",
    options: [
      "The service brakes lock up automatically",
      "The service brakes become completely ineffective — the vehicle cannot be stopped with brakes",
      "The ABS takes over",
      "The engine braking alone is sufficient to stop",
    ],
    answer: 1,
    explanation: "Without air pressure and without spring brakes, there is NO braking ability. This is why spring brakes are a critical safety requirement on modern CMVs.",
  },
  {
    id: "ab064",
    question: "What is 'brake lag' in an air brake system?",
    options: [
      "Delay between the driver pressing the brake pedal and when air reaches the brake chambers",
      "The time it takes for the driver to move their foot to the brake pedal",
      "The distance the vehicle travels after brakes are applied",
      "A reduction in brake force after the drums heat up",
    ],
    answer: 0,
    explanation: "Brake lag is the delay from when the driver presses the pedal to when air reaches and fills the brake chambers. This adds to total stopping distance compared to hydraulic brakes.",
  },
  {
    id: "ab065",
    question: "Compared to hydraulic brake systems, air brake systems have a longer stopping distance because:",
    options: [
      "Air brakes are less powerful",
      "Air takes time to travel through lines and fill chambers before the brakes apply (brake lag)",
      "Air brakes are older technology",
      "Air brakes only work on rear axles",
    ],
    answer: 1,
    explanation: "Air must travel from the foot valve through lines to chambers — this takes time. Brake lag adds about 0.4 seconds to stopping time compared to hydraulic systems.",
  },
  {
    id: "ab066",
    question: "What is the proper way to hold pressure on the service brakes when stopped on a grade?",
    options: [
      "Release the service brakes and set the spring brake only",
      "Hold the service brakes with foot pressure and also apply the spring (parking) brake",
      "Apply the trailer brake only",
      "Only use the engine brake",
    ],
    answer: 1,
    explanation: "When stopped on a grade, hold the service brake with your foot AND apply the spring brake. Relying on only one system risks roll-away.",
  },
  {
    id: "ab067",
    question: "What causes 'compressor knock' and what does it indicate?",
    options: [
      "Normal compressor operation at high pressure",
      "Knocking sounds from the compressor may indicate worn parts, excessive carbon buildup, or oil contamination — requires inspection",
      "The governor cycling on and off rapidly",
      "Air lines vibrating at highway speeds",
    ],
    answer: 1,
    explanation: "Unusual knocking from the compressor indicates internal wear or contamination. The compressor should be inspected and repaired before continued operation.",
  },
  {
    id: "ab068",
    question: "The air dryer purge valve should:",
    options: [
      "Never release air — any release is a malfunction",
      "Periodically expel moisture and contaminants from the dryer — this is normal operation",
      "Only operate when the brakes are applied",
      "Only operate at highway speeds",
    ],
    answer: 1,
    explanation: "Automatic air dryers periodically purge accumulated moisture — you'll hear a 'pfft' of air during or after compressor cycles. This is normal and expected.",
  },
  {
    id: "ab069",
    question: "What is the function of the quick release valve in an air brake system?",
    options: [
      "To quickly supply air to the brake chambers",
      "To allow faster release of air from the brake chambers after the brakes are released, speeding up brake release",
      "To release air from the tanks in an emergency",
      "To control the spring brake release",
    ],
    answer: 1,
    explanation: "The quick release valve is located near the brake chambers. When the brake pedal is released, it rapidly vents air from the chambers to allow fast brake release.",
  },
  {
    id: "ab070",
    question: "What is a 'limiting valve' (also called a front axle limiting valve)?",
    options: [
      "A valve that prevents brake pressure from exceeding 100 psi",
      "A valve that reduces air pressure to the front axle brakes by 50% when engaged, used on slippery roads",
      "A valve that limits trailer air pressure",
      "A valve that controls maximum engine RPM",
    ],
    answer: 1,
    explanation: "Limiting valves are optional devices that can reduce front brake pressure in slippery conditions to prevent front wheel lockup, though many newer vehicles rely on ABS instead.",
  },
  {
    id: "ab071",
    question: "At what ambient temperature does water in brake lines and tanks present the greatest risk of freezing?",
    options: [
      "Only below 0°F",
      "Below 32°F (0°C) — at or below freezing temperatures",
      "Below 20°F",
      "Water in air lines cannot freeze",
    ],
    answer: 1,
    explanation: "Water in air lines and valves can freeze at 32°F (0°C) or below, blocking air flow and causing partial or complete brake failure.",
  },
  {
    id: "ab072",
    question: "What must you do before removing any air line that is under pressure?",
    options: [
      "Nothing — air lines can be removed at any time",
      "Depressurize the system by draining the tanks and applying the brakes",
      "Only block the wheels",
      "Turn off the engine only",
    ],
    answer: 1,
    explanation: "Never disconnect pressurized air lines. Depressurize the tanks and release trapped air in the lines before removing any fittings or lines.",
  },
  {
    id: "ab073",
    question: "What is the function of the differential pressure valve (also called a double check valve)?",
    options: [
      "To equalize pressure between front and rear brakes",
      "To supply the brakes from whichever of two air sources (primary or secondary) has the higher pressure",
      "To prevent reverse air flow",
      "To signal the driver of brake imbalance",
    ],
    answer: 1,
    explanation: "The double check valve automatically selects the higher-pressure source from the two circuits, ensuring maximum air is always available to the brakes.",
  },
  {
    id: "ab074",
    question: "If you are going down a long, steep grade and your truck speed begins to increase despite holding constant brake pressure, this may indicate:",
    options: [
      "The ABS is activating normally",
      "Brake fade — the brakes are overheating and losing effectiveness",
      "The governor is failing",
      "A normal result of gravity",
    ],
    answer: 1,
    explanation: "If vehicle speed increases despite braking, the brakes are fading from heat. Shift to a lower gear immediately and head for a runaway truck ramp if speed continues to build.",
  },
  {
    id: "ab075",
    question: "When parking a vehicle with air brakes on a hill, you must:",
    options: [
      "Only engage the spring brake",
      "Engage the spring brake and chock the wheels because spring brakes alone can fail over time with slow air leakage",
      "Park in gear only",
      "Use only wheel chocks",
    ],
    answer: 1,
    explanation: "Spring brakes hold the vehicle but air can slowly leak, reducing holding force. Chock wheels for extended parking, especially on grades.",
  },
  // ── UPDATED / ADDITIONAL CONCEPTS 2025-2026 ──────────────────────────────────
  {
    id: "ab076",
    question: "What are 'wedge brakes' and how do they differ from S-cam brakes?",
    options: [
      "Wedge brakes use a disc rotor; S-cam brakes use drum-and-shoe",
      "Wedge brakes use a wedge driven between the brake shoes to spread them; S-cam brakes rotate an S-shaped cam to spread the shoes",
      "Wedge brakes are used only on front axles; S-cam on rear axles",
      "They are the same system with different names",
    ],
    answer: 1,
    explanation: "Both are drum-brake designs. S-cam brakes use a rotating S-shaped cam to push the shoes apart. Wedge brakes use air pressure to drive a wedge between the shoes. Wedge brakes can be self-adjusting.",
  },
  {
    id: "ab077",
    question: "What is a 'disc brake' on a commercial vehicle and what is one advantage over drum brakes?",
    options: [
      "A disc brake uses a rotor and caliper; its main advantage is self-adjusting slack",
      "A disc brake uses a rotor clamped by a caliper; it dissipates heat more effectively and is less prone to brake fade on long grades",
      "A disc brake relies entirely on spring pressure; it cannot fade",
      "Disc brakes are prohibited on CMVs over 80,000 lbs",
    ],
    answer: 1,
    explanation: "Air disc brakes use a rotor and caliper similar to a car's disc brake. They offer superior heat dissipation, more consistent stopping power, and reduced brake fade compared to drum brakes.",
  },
  {
    id: "ab078",
    question: "What is an 'automatic slack adjuster' and what is its purpose?",
    options: [
      "A device that automatically adjusts air pressure in the brake chambers",
      "A self-adjusting mechanism on the brake camshaft that maintains proper brake shoe-to-drum clearance automatically as linings wear",
      "A sensor that tells the driver when to adjust the brakes manually",
      "A valve that limits slack in the air lines between the tractor and trailer",
    ],
    answer: 1,
    explanation: "Automatic slack adjusters (ASAs) compensate for brake lining wear by automatically maintaining the correct clearance between the shoe and drum. Even with ASAs, drivers must still check for proper stroke during inspections.",
  },
  {
    id: "ab079",
    question: "What is the maximum allowable brake chamber push-rod stroke for a standard type 30 brake chamber?",
    options: ["1.5 inches", "2 inches", "2.5 inches", "3 inches"],
    answer: 1,
    explanation: "For a type 30 brake chamber, the maximum allowable applied push-rod stroke before the brake is considered out of adjustment is 2 inches. Stroke limits vary by chamber type — always check the applicable standard.",
  },
  {
    id: "ab080",
    question: "During a pre-trip brake test, after the engine is off and air pressure is built up, you should apply the foot brake and hold it for one minute. A safe system should:",
    options: [
      "Show a drop of more than 3 psi per minute, which is normal",
      "Show a loss of no more than 3 psi in one minute for single vehicles or 4 psi for combination vehicles",
      "Show zero pressure loss — any loss is a defect",
      "Show a drop of up to 10 psi before the alarm sounds",
    ],
    answer: 1,
    explanation: "After the engine is off and pressure is built, hold the service brake for one minute. Acceptable leakage is no more than 3 psi for single vehicles or 4 psi for combination vehicles. Higher loss indicates a leak.",
  },
  {
    id: "ab081",
    question: "What is the 'anti-compounding' valve in an air brake system?",
    options: [
      "A valve that prevents the service brakes and spring brakes from applying simultaneously, which could damage the brake chambers",
      "A valve that prevents air from compressing past a safe pressure",
      "A relay valve that speeds up service brake application",
      "A dual check valve that prevents air from backing up into the compressor",
    ],
    answer: 0,
    explanation: "The anti-compounding valve (also called the spring brake modulating valve) prevents both the service brakes and spring brakes from applying at the same time. Simultaneous application could overstress and damage brake components.",
  },
  {
    id: "ab082",
    question: "The 'tractor protection valve' closes automatically when trailer air pressure drops to approximately:",
    options: ["45 psi", "20–45 psi", "60 psi", "100 psi"],
    answer: 1,
    explanation: "The tractor protection valve closes — cutting off air supply to the trailer and applying the trailer spring brakes — when trailer air pressure drops to approximately 20–45 psi, protecting the tractor's air supply.",
  },
  {
    id: "ab083",
    question: "What happens to a vehicle's stopping distance when the brakes are applied in a skid?",
    options: [
      "Stopping distance decreases because maximum friction is applied",
      "Stopping distance increases because locked wheels create less friction than wheels that are still rolling, and steering control is lost",
      "Stopping distance stays the same — friction is constant",
      "Stopping distance decreases on wet surfaces but increases on dry",
    ],
    answer: 1,
    explanation: "Locked, skidding wheels generate less friction (sliding friction) than rolling wheels near lockup (rolling friction). This increases stopping distance and eliminates steering control.",
  },
  {
    id: "ab084",
    question: "What is the correct action if your vehicle's ABS activates during emergency braking?",
    options: [
      "Pump the brake pedal rapidly to help the ABS",
      "Release the brakes completely, then reapply",
      "Maintain steady, firm pressure on the brake pedal and steer normally — the ABS will modulate the brakes automatically",
      "Apply only light pressure to avoid overriding the ABS",
    ],
    answer: 2,
    explanation: "ABS automatically modulates braking to prevent lockup. The correct response is to maintain firm brake pressure and steer normally. Do not pump the brakes — that defeats the ABS.",
  },
  {
    id: "ab085",
    question: "What is the 'low pressure warning device' and at what pressure does it activate?",
    options: [
      "A valve that applies the brakes; activates at 100 psi",
      "A warning light and/or buzzer that alerts the driver when air pressure drops below approximately 60 psi",
      "A sensor that activates the spring brakes at 40 psi",
      "A device that sounds an alarm when pressure reaches maximum",
    ],
    answer: 1,
    explanation: "The low pressure warning device (light and/or buzzer) must activate before pressure drops below 60 psi. This warns the driver to stop safely before pressure falls to the spring brake activation level (~20–45 psi).",
  },
  {
    id: "ab086",
    question: "What is 'brake fade' and what causes it?",
    options: [
      "A gradual decrease in brake pedal travel due to adjustment",
      "A loss of braking effectiveness caused by heat buildup in the brake drums, which reduces friction between the drum and linings",
      "Brake failure caused by air pressure dropping below 20 psi",
      "The tendency of brakes to apply unevenly on a slippery surface",
    ],
    answer: 1,
    explanation: "Brake fade occurs when repeated brake applications overheat the drums and linings, reducing the friction needed to slow the vehicle. It is especially dangerous on long downgrades.",
  },
  {
    id: "ab087",
    question: "When descending a long, steep grade, which braking technique is recommended to avoid brake fade?",
    options: [
      "Apply the service brakes hard all the way down to minimize time",
      "Select the right gear before starting down so engine braking does most of the work, with light, controlled brake applications to maintain safe speed",
      "Use the parking brake in short bursts to supplement the service brakes",
      "Use the service brakes continuously at moderate pressure throughout the descent",
    ],
    answer: 1,
    explanation: "Select a low gear before descending so engine compression does most of the braking work. Apply the service brakes in controlled applications (about 10 seconds each) when needed, releasing to allow them to cool.",
  },
  {
    id: "ab088",
    question: "What does the 'glad hands' connect?",
    options: [
      "The electrical connections between tractor and trailer",
      "The air supply lines between the tractor and trailer — one for service air and one for the emergency/supply line",
      "The fifth-wheel air assist system",
      "The hydraulic brake lines on combination vehicles",
    ],
    answer: 1,
    explanation: "Glad hands are the couplings that connect the air lines between the tractor and trailer. The service line (blue or red) carries brake application air; the emergency/supply line (red) supplies air to the trailer tanks.",
  },
  {
    id: "ab089",
    question: "What color are the glad hand couplers and air lines on a standard tractor-trailer?",
    options: [
      "Both are blue",
      "Service line = blue; Emergency/supply line = red",
      "Service line = red; Emergency/supply line = blue",
      "Color coding is not standardized — always check markings",
    ],
    answer: 1,
    explanation: "Industry standard: the service (control) line is blue and the emergency (supply) line is red. Some manufacturers use different markings, so always verify, but blue = service and red = emergency is the standard.",
  },
  {
    id: "ab090",
    question: "What is the 'air dryer' in an air brake system and why is it important?",
    options: [
      "A heater that prevents the air tanks from freezing",
      "A device that removes moisture and contaminants from compressed air before it reaches the tanks, reducing the risk of valve icing and component corrosion",
      "A filter that cleans the air entering the air compressor",
      "A pressure regulator that maintains the governor cut-in pressure",
    ],
    answer: 1,
    explanation: "The air dryer removes water vapor, oil, and other contaminants from the compressed air. This prevents moisture from freezing in valves and lines in cold weather and reduces corrosion in the air system.",
  },
  // ── MBTA ENDORSEMENT TEST 1 ───────────────────────────────────────────────────
  {
    id: "ab091",
    question: "What is emergency stab braking? (5.4.3)",
    options: [
      "Press hard on the brake pedal and apply the hand valve until you stop",
      "Use light steady pressure on the brake pedal",
      "Brake hard, release the brakes when the wheels lock and reapply the brakes when the wheels start rolling",
    ],
    answer: 2,
    explanation: "Stab braking: apply brakes fully, release when wheels lock, reapply when wheels start rolling again. This lets you steer while stopping.",
  },
  {
    id: "ab092",
    question: "The air brake lag distance at 55 mph on dry pavement adds about ___ feet to your stopping distance. (5.4.4)",
    options: ["12", "52", "32"],
    answer: 2,
    explanation: "Air brake lag adds about 32 feet to stopping distance at 55 mph compared to hydraulic brakes.",
  },
  {
    id: "ab093",
    question: "You should know that your brakes are fading when: (5.4.5)",
    options: [
      "You have to push harder on the brake pedal to control your speed as speed increases",
      "Pressure on the brake pedal is released and speed increases",
      "Less pressure is needed on the brake pedal for each stop",
    ],
    answer: 0,
    explanation: "Brake fade means you must push harder and harder on the pedal to maintain the same braking effect as the drums and linings overheat.",
  },
  {
    id: "ab094",
    question: "Excessive use of the service brakes results in overheating, which can lead to: (5.4.5)",
    options: [
      "Improper adjustment of the S-cam",
      "Increased contact between the brake drums and brake linings",
      "Expansion of the brake drums",
    ],
    answer: 2,
    explanation: "Overheated brake drums expand, reducing contact with the linings and causing loss of braking effectiveness (fade).",
  },
  {
    id: "ab095",
    question: "The proper method of braking when going down long and/or steep grades, after selecting the proper gear, is to brake until your speed is about ___ miles per hour below your 'safe' speed. (5.4.6)",
    options: ["5", "10", "15"],
    answer: 0,
    explanation: "Brake until speed drops about 5 mph below your safe speed, then release and let brakes cool before repeating.",
  },
  {
    id: "ab096",
    question: "Which of these is NOT a proper time to apply the parking brakes? (5.4.8)",
    options: [
      "When you will only be stopped for less than one hour",
      "When you are going to test the parking brake",
      "When you come down a steep grade and your brakes are very hot",
    ],
    answer: 2,
    explanation: "Never apply spring/parking brakes when they are very hot — the heat can damage them. Allow brakes to cool before setting the parking brake.",
  },
  {
    id: "ab097",
    question: "For safe downhill braking the air brake system should apply: (5)",
    options: [
      "Equal brake pressure at each wheel",
      "Less pressure to the front wheels",
      "More pressure to the rear wheels",
      "More pressure to the drive wheels",
    ],
    answer: 0,
    explanation: "Proper air brake systems distribute equal pressure to all wheels for balanced, safe stopping.",
  },
  {
    id: "ab098",
    question: "The air compressor governor controls: (5.1.2)",
    options: [
      "The upward and downward travel of the engine pistons",
      "When the compressor will pump air into the storage tanks",
      "The air pressure in the inlet valve",
    ],
    answer: 1,
    explanation: "The governor controls when the compressor cuts in (starts pumping) and cuts out (stops pumping) to maintain pressure in the normal operating range.",
  },
  {
    id: "ab099",
    question: "Vehicles without automatic tank drains should have their air brakes drained: (5.1.3)",
    options: [
      "At least once a week",
      "Every 500 miles or once a week",
      "Every day the vehicle is driven",
    ],
    answer: 2,
    explanation: "Tanks without automatic drains must be manually drained at the end of each day's driving to remove water and oil that accumulate.",
  },
  {
    id: "ab100",
    question: "The brake system that applies and releases the brakes when the driver uses the brake pedal is the ___ brake system. (5)",
    options: ["Emergency", "Service", "Parking", "Automatic"],
    answer: 1,
    explanation: "The service brake system is controlled by the foot pedal and is used for normal stopping and slowing.",
  },
  {
    id: "ab101",
    question: "If your truck's air compressor has its own oil supply, when should you first check the oil level? (5.1.2)",
    options: [
      "Before driving",
      "During your first en-route inspection",
      "Immediately after you stop driving",
      "Only during extremely hot weather",
    ],
    answer: 0,
    explanation: "Check the compressor oil level before driving as part of the pre-trip inspection.",
  },
  {
    id: "ab102",
    question: "Why drain air storage tanks? (5.1.4)",
    options: [
      "The air storage tanks do not need to be drained if the safety valve is set high enough",
      "Water in an air tank can freeze in cold weather and cause brake failure",
      "Compressed air can become overheated, which then reduces braking power",
      "Water collects in the tank and can overcool the compressor",
    ],
    answer: 1,
    explanation: "Water accumulates in the tanks from compressed air. In cold weather it can freeze and block air lines, causing brake failure.",
  },
  {
    id: "ab103",
    question: "The safety valve is usually set to reduce air pressure at ___ psi. (5.1.6)",
    options: ["50", "100", "150", "200"],
    answer: 2,
    explanation: "The safety (relief) valve opens at about 150 psi to prevent over-pressurization if the governor fails.",
  },
  {
    id: "ab104",
    question: "The driver must be able to see a warning before air pressure in the service air tanks falls below ___ psi. (5.1.11)",
    options: ["50", "60", "80"],
    answer: 1,
    explanation: "The low air pressure warning must activate before pressure drops below 60 psi, giving the driver time to stop safely.",
  },
  {
    id: "ab105",
    question: "During normal driving, spring brakes are usually held back by: (5.1.15)",
    options: ["Bolts", "Spring pressure", "Air pressure"],
    answer: 2,
    explanation: "Air pressure compresses the large coil springs in the spring brake chambers, holding the parking/emergency brakes released during normal driving.",
  },
  {
    id: "ab106",
    question: "If your truck or bus has dual parking control valves, you can use pressure from a separate tank to: (5.1.15)",
    options: [
      "Release spring emergency/parking brakes to move a short distance",
      "Apply more brake pressure if the main tank is getting low",
      "Balance the service brake system whenever you are parked",
    ],
    answer: 0,
    explanation: "Dual parking control valves allow a separate air supply to release the spring brakes so you can move the vehicle a short distance even with low main tank pressure.",
  },
  {
    id: "ab107",
    question: "Before driving a truck or bus with a dual air brake system, the pressure in each system should be at least ___ psi. (5.2)",
    options: ["80", "100", "120"],
    answer: 1,
    explanation: "Both circuits of a dual air brake system must show at least 100 psi before you begin driving.",
  },
  {
    id: "ab108",
    question: "To check the free play of manual slack adjusters on S-cam brakes, you should park on level ground: (5.3.2)",
    options: [
      "Chock the wheels and turn off the parking brake",
      "With the parking brake released, then apply the service brake",
      "And drain off air pressure before adjusting vehicle movement",
    ],
    answer: 0,
    explanation: "Chock the wheels and release the parking brake so you can manually move the slack adjuster to check for proper free play without the vehicle rolling.",
  },
  {
    id: "ab109",
    question: "The parking air brake system for a truck or bus should not leak at a rate of more than ___ psi per minute with the engine off and the brakes released. (5.3.3)",
    options: ["1", "2", "3"],
    answer: 1,
    explanation: "With engine off and brakes released, acceptable leakage for a single vehicle is no more than 2 psi per minute.",
  },
  {
    id: "ab110",
    question: "If you must make an emergency stop, brake so you: (5.4.3)",
    options: [
      "Can steer hard while braking hard",
      "Use the hand brake first",
      "Can steer your vehicle in a straight line",
    ],
    answer: 2,
    explanation: "In an emergency stop, maintain steering control by keeping the vehicle in a straight line — brake hard but keep the wheels from locking.",
  },
  {
    id: "ab111",
    question: "Total stopping distance for vehicles with air brakes is longer than that for vehicles with hydraulic brakes due to ___ distance. (5.4.4)",
    options: ["Brake lag", "Reaction", "Effective braking"],
    answer: 0,
    explanation: "Air must travel from the foot valve through the lines to the brake chambers, adding brake lag distance that does not exist in hydraulic systems.",
  },
  {
    id: "ab112",
    question: "How should you check that your service brakes are working properly? (5.3.3)",
    options: [
      "Park on a slight incline, drain off air pressure, set the parking brakes and check for movement",
      "Park on level ground, chock the wheels, engage the parking brake, and shut the engine off",
      "Wait for normal air pressure, release the parking brake, move the truck forward slowly and firmly step on the brake",
    ],
    answer: 2,
    explanation: "Build normal air pressure, release the parking brake, move forward slowly, then apply the service brakes firmly to verify they stop the vehicle properly.",
  },
  {
    id: "ab113",
    question: "During normal driving, parking and emergency brakes are usually held by: (5.1.15)",
    options: [
      "Spring brakes",
      "Dual parking control valve",
      "Front wheel limiting valve",
      "Mechanical force",
    ],
    answer: 3,
    explanation: "The parking and emergency brakes are spring-applied — they are held on by mechanical (spring) force and released by air pressure.",
  },
  {
    id: "ab114",
    question: "If your vehicle has an alcohol evaporator, every day during cold weather, you should: (5.1.5)",
    options: [
      "Check and fill the alcohol level",
      "Drain the alcohol by briefly opening the drain cock",
      "Use only grade A alcohol",
      "Drain the larger reservoir only in a vehicle equipped with more than one reservoir",
    ],
    answer: 0,
    explanation: "Check and refill the alcohol evaporator daily in cold weather to ensure it can keep injecting alcohol to prevent moisture from freezing in the air lines.",
  },
  {
    id: "ab115",
    question: "The air compressor should stop pumping at about ___ psi. (5.1.2)",
    options: ["100", "115", "125", "150"],
    answer: 2,
    explanation: "The governor cuts out (stops the compressor) at about 125 psi, which is the top of the normal operating pressure range.",
  },
  {
    id: "ab116",
    question: "The braking power of the spring brakes: (5.1.15)",
    options: [
      "Is applied without air pressure from the service brake system",
      "Is controlled by the automatic front wheel limiting system",
      "Is not affected by the condition of the service brakes",
      "Depends on the service brakes being in adjustment",
    ],
    answer: 3,
    explanation: "Spring brakes work through the mechanical force of large coil springs, but their effectiveness still depends on the service brakes (shoes, drums, linings) being in proper adjustment.",
  },
  {
    id: "ab117",
    question: "Your truck or bus has a dual air brake system. If a low air pressure warning comes on for only one system, what should you do? (5.2)",
    options: [
      "Reduce your speed and drive to the nearest garage for repairs",
      "Reduce your speed and test the remaining system while driving",
      "Stop and safely park. Continue only after the system is fixed",
    ],
    answer: 2,
    explanation: "Any low air pressure warning is serious. Stop safely and do not drive until the brake system problem is repaired — even in a dual system.",
  },
  {
    id: "ab118",
    question: "A truck with air brakes going 55 mph would require a stopping distance of: (5.2)",
    options: [
      "Less than 100 feet",
      "100-300 feet",
      "More than 300 feet",
    ],
    answer: 2,
    explanation: "A fully loaded truck at 55 mph needs more than 300 feet to stop — this is significantly more than a car due to vehicle weight and air brake lag time.",
  },
  {
    id: "ab119",
    question: "The brake pedal in an air brake system: (5.1.7)",
    options: [
      "Controls the speed of the air compressor",
      "Controls the air pressure applied to put on the brakes",
      "Connects the slack adjusters by a series of rods and linkage",
      "Connects the slack adjusters by a series of air lines and hoses",
    ],
    answer: 1,
    explanation: "The brake pedal (foot valve/treadle valve) controls the air pressure delivered to the brake chambers, which then apply the brakes.",
  },
  {
    id: "ab120",
    question: "A full service brake application must deliver to all brake chambers not less than what of the air reservoir pressure? (5)",
    options: [
      "All brake chambers: 90%",
      "The rear brake chamber: 90%",
      "All brake chambers: 75%",
      "The front brake chamber: 80%",
    ],
    answer: 0,
    explanation: "A full service brake application must supply at least 90% of the reservoir pressure to all brake chambers to ensure effective braking.",
  },
  {
    id: "ab121",
    question: "The application pressure gauge shows how much air pressure you: (5.1.10)",
    options: [
      "Have in the air tanks",
      "Have in the modulating control valve",
      "Are applying to the brakes",
    ],
    answer: 2,
    explanation: "The application pressure gauge (brake application gauge) shows the air pressure being applied to the brake chambers when you press the brake pedal.",
  },
  {
    id: "ab122",
    question: "The use of air brakes on a downgrade is only a supplement to the: (5.4.6)",
    options: [
      "Use of the spring brakes",
      "Use of the front brake limiting valve",
      "Braking effect of the engine",
    ],
    answer: 2,
    explanation: "On a long downgrade, the primary braking should come from engine braking (low gear). Air brakes are a supplement only — using them too much causes brake fade from heat buildup.",
  },
  {
    id: "ab123",
    question: "In vehicles with air brake systems, the parking brakes: (5.4.8)",
    options: [
      "Should normally be used as long as the main reservoir pressure is not empty",
      "Are used to maintain speed when going downhill",
      "Must be operated manually by pushing in the control valve",
      "Should normally be used anytime the vehicle is parked",
    ],
    answer: 3,
    explanation: "The parking brake (spring brake) should be set anytime the vehicle is parked. Never rely solely on leaving the vehicle in gear — always set the parking brake.",
  },
  {
    id: "ab124",
    question: "The parking or emergency brake on a heavy vehicle can only be held in position by something that cannot leak away, like: (5.1.15)",
    options: [
      "Spring pressure",
      "Air pressure",
      "Hydraulic pressure",
    ],
    answer: 0,
    explanation: "Air and hydraulic pressure can leak away over time, leaving no braking force. Spring pressure is always present and cannot leak, making it reliable for parking/emergency brakes.",
  },
  {
    id: "ab125",
    question: "If the air compressor develops a leak, what keeps the air in the tanks? (5.2)",
    options: [
      "The foot valve treadle",
      "The one-way check valve",
      "The trailer supply valve",
      "The main reservoir",
    ],
    answer: 1,
    explanation: "A one-way check valve between the compressor and the air tanks prevents air from flowing back out if the compressor fails or develops a leak.",
  },
  {
    id: "ab126",
    question: "Your truck has a properly functioning dual air brake system and minimum size air tanks. The air pressure should build from 85 to 100 psi within: (5.3.3)",
    options: [
      "30 seconds",
      "45 seconds",
      "60 seconds",
    ],
    answer: 1,
    explanation: "In a properly functioning dual air brake system with minimum size tanks, pressure should build from 85 to 100 psi within 45 seconds. Longer build time indicates a problem.",
  },
  {
    id: "ab127",
    question: "What is emergency controlled braking? (5.4.3)",
    options: [
      "You apply the brakes as hard as you can without locking the wheels",
      "You brake as hard as you can, release the brakes when the wheels lock, and reapply the brakes when the wheels start rolling",
      "You apply the hand valve for one second, then push hard on the brake pedal",
    ],
    answer: 1,
    explanation: "Emergency controlled braking (also called threshold braking) means applying brakes hard, releasing when wheels lock up, then reapplying — maintaining maximum braking without losing steering control.",
  },
  {
    id: "ab128",
    question: "Vehicles with air brakes must have: (5)",
    options: [
      "At least two air tanks",
      "A low air pressure warning device",
      "An air application pressure gauge",
      "A front brake limiting valve which is controlled from the cab",
    ],
    answer: 1,
    explanation: "All air brake equipped vehicles are required by law to have a low air pressure warning device (light and/or buzzer) that activates before pressure drops to a dangerous level.",
  },
  {
    id: "ab129",
    question: "Repeatedly pressing and releasing (fanning the brake pedal) may result in: (5.1.7)",
    options: [
      "A loss of brake air pressure",
      "A buildup of brake air pressure",
      "No change in brake air pressure",
    ],
    answer: 0,
    explanation: "Each brake application uses air. If the compressor cannot keep up, fanning the brakes rapidly depletes the air supply and can cause brake failure.",
  },
  {
    id: "ab130",
    question: "If air pressure does not build up to normal within the correct amount of time: (5.2)",
    options: [
      "You should be ready to use your parking brake to help stop",
      "The alcohol container may be low",
      "Your air pressure may drop too low during driving",
    ],
    answer: 2,
    explanation: "If the system takes too long to build pressure, there may be a leak or compressor problem. This can lead to dangerously low pressure while driving.",
  },
  {
    id: "ab131",
    question: "All air brake equipped vehicles have: (5.1.9)",
    options: [
      "An air usage gauge",
      "A backup hydraulic system",
      "An air supply pressure gauge",
    ],
    answer: 2,
    explanation: "Every air brake system must have a supply pressure gauge (also called the air pressure gauge) so the driver can monitor system pressure at all times.",
  },
  {
    id: "ab132",
    question: "The supply pressure gauge: (5.1.9)",
    options: [
      "Increases the air pressure to the front wheels to prevent skidding",
      "Allows air to flow in one direction only",
      "Shows how much pressure is in the air tanks",
      "Allows for increased pressure to the brake pedal",
    ],
    answer: 2,
    explanation: "The supply (reservoir) pressure gauge shows the amount of air pressure in the tanks. Normal operating range is 100–125 psi.",
  },
  {
    id: "ab133",
    question: "When you apply the brakes, the brake shoes/linings are pressed against the: (5.1.8)",
    options: [
      "Slack adjuster",
      "Brake drum or disc",
      "S-cam",
    ],
    answer: 1,
    explanation: "Applying the brakes forces the brake shoes (with their linings) outward against the brake drum (or pads against disc), creating friction that slows the wheel.",
  },
  {
    id: "ab134",
    question: "Air braking takes more time than hydraulic braking because air brakes: (5.4.4)",
    options: [
      "Use different types of hoses and lines",
      "Need to have air flow through the lines to work",
      "Require heavier return springs",
      "Increase the friction to the brake drums which causes more heat",
    ],
    answer: 1,
    explanation: "Air must physically flow through the lines to the brake chambers before braking force is applied. This transit time creates brake lag — about 0.4 seconds longer than hydraulic systems.",
  },
  {
    id: "ab135",
    question: "The first thing to do when a low air pressure warning comes on is: (5.4.7)",
    options: [
      "Stop and safely park as soon as possible",
      "Stop and adjust the brake pedal for more travel",
      "Stop and open the air supply control valve",
      "Stop and adjust the vehicle's load so that more weight is on the drive axle",
    ],
    answer: 0,
    explanation: "A low air pressure warning means the system is losing pressure. Stop immediately and park safely — do not continue driving or air pressure may drop to the point where spring brakes apply automatically.",
  },
  {
    id: "ab136",
    question: "Your vehicle has a dual air brake system. If a low air pressure warning comes on for the secondary system, you should: (5.2)",
    options: [
      "Stop the vehicle and continue only when the system is fixed",
      "Reduce your speed, and test the remaining system while driving",
      "Reduce your speed, and drive to the nearest garage for repairs",
    ],
    answer: 2,
    explanation: "With a dual system, if the secondary circuit loses pressure, the primary circuit still functions. Reduce speed and drive carefully to the nearest repair facility.",
  },
  {
    id: "ab137",
    question: "Under normal conditions, to engage the parking brake the driver must first: (5.1.14)",
    options: [
      "Turn off the engine only",
      "Let the air out of the air brake system",
      "Be sure the air brake system is fully pressurized",
      "Be sure all doors are closed",
    ],
    answer: 1,
    explanation: "To set the parking (spring) brake, push in the yellow diamond-shaped control, which releases air from the spring brake chambers and allows the springs to apply the brakes.",
  },
  {
    id: "ab138",
    question: "If your vehicle has an alcohol evaporator, it is there to: (5.1.5)",
    options: [
      "Rid the wet tank of alcohol that condenses and sits at the bottom",
      "Eliminate the need for daily tank draining",
      "Reduce the risk of ice in air brake valves in cold weather",
    ],
    answer: 2,
    explanation: "The alcohol evaporator injects alcohol vapor into the air system to lower the freezing point of moisture, preventing ice formation in valves and lines during cold weather.",
  },
];

export default airBrakes;
